export const LOAD_MODERATORS = 'LOAD_MODERATORS'
export const LOAD_PRESENTATORS = 'LOAD_PRESENTATORS'
export const LOAD_ATELIER_PROGRAMS = 'LOAD_ATELIER_PROGRAMS'
export const LOAD_PLANNINGS = 'LOAD_PLANNINGS'
export const LOAD_PROGRAM_ENUMS = 'LOAD_PROGRAM_ENUMS'
export const LOAD_ATELIER_TYPE_ENUMS = 'LOAD_ATELIER_TYPE_ENUMS'
export const SET_CURRENT_PLANNING = 'SET_CURRENT_PLANNING'